






module.exports = {
    name: 'line'
    props: ['beats', 'currentNote', 'onNotes', 'pitch']
    computed: {
        beatsArray: () ->
            it = new Array(this.beats)
            for onNote in @onNotes
                if onNote < this.beats
                    it[onNote] = true
            return it
    },
    methods: {
        handleClick: (index) ->
            this.$emit('toggle-box', this.pitch, index)
    }
}




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/Line.vue